// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__xTnIT","modal":"Modal_modal__DJDMv","profile":"Modal_profile__yOe+T","dates":"Modal_dates__hDRtO","button":"Modal_button__PTCbC"};